var _circle, _circle2, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 27.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7587 15.3678V19.0484C19.7921 20.16 17.3155 22.2768 15.7405 24.983V14H21.3937C22.1469 14 22.7587 14.6118 22.7587 15.3678Z",
    fill: "#3E8445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5148 20.0271V23.5537C32.5148 25.4983 30.9384 27.0747 28.9938 27.0747H27.8458C25.0458 27.0747 22.7736 29.3413 22.768 32.1441V42.0001H17.1078C16.3518 42.0001 15.7414 41.3883 15.7414 40.6337V32.2855C15.7358 32.1399 15.733 31.9943 15.733 31.8473C15.733 25.3149 21.0292 20.0173 27.563 20.0173C27.71 20.0173 27.8556 20.0201 28.0026 20.0257H32.5148V20.0271Z",
    fill: "#3E8445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.339 40.6322V36.9516C37.307 35.8386 39.7836 33.7218 41.3572 31.0156V42H35.704C34.9522 42 34.339 41.3882 34.339 40.6322Z",
    fill: "#3E8445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5852 35.973V32.4464C24.5852 30.5018 26.1616 28.9254 28.1062 28.9254H29.2542C32.0542 28.9254 34.3264 26.6588 34.332 23.856V14H39.9922C40.7482 14 41.3586 14.6118 41.3586 15.3664V23.7146C41.3656 23.8602 41.367 24.0058 41.367 24.1542C41.367 30.6866 36.0708 35.9842 29.537 35.9842C29.39 35.9842 29.2444 35.9814 29.0974 35.9758H24.5852V35.973Z",
    fill: "#3E8445"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeco);
export default __webpack_public_path__ + "static/media/heco.268c2642.svg";
export { ForwardRef as ReactComponent };